import {ChatStatus} from '../../copilot.enums';
import {ChatState} from '../../copilot.types';

export default function chatState(chatId: string): ChatState {
  return {
    id: chatId,
    chatItems: [],
    modalWidget: null,
    blockingChatItemId: null,
    informationText: '',
    draftMessage: {
      text: '',
      fileIds: [],
    },
    plan: null,
    status: ChatStatus.Idle,
    isPlanModeToggleOn: false,
  };
}
